<template>
    <div class="row">
        <div class="col-4" v-if="options">
            <div class="card shadow">
                <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 class="m-0 font-weight-bold text-primary">
                        Konfiguration
                    </h6>
                </div>
                <div class="card-body">

                    <div class="form-group">
                        <label>
                            Seite
                        </label>
                        <select class="form-control" v-model="chartConfig.pageIndex">
                            <option :value="null">Bitte wählen</option>
                            <option :value="page.index" v-for="page in options.pages">{{ page.title }}</option>
                        </select>
                    </div>

                    <template v-if="chartConfig.pageIndex !== null">

                        <div class="form-group">
                            <label>
                                Zeilen
                            </label>
                            <custom-select v-model="chartConfig.primaryRowIds"
                                           :options="selectableRows"
                                           :settings="{multiple: true}"/>
                            <div class="mt-1">
                                <a href="#"
                                   @click.prevent="chartConfig.primaryRowIds = options.pages[chartConfig.pageIndex].selectable_rows.map((row) => row.id)">
                                    <small>
                                        <i class="fas fa-fw fa-plus-circle"></i>
                                        Alle
                                    </small>
                                </a>
                                |
                                <a href="#" @click.prevent="chartConfig.primaryRowIds = []">
                                    <small>Leeren</small>
                                </a>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>
                                Spalten
                            </label>
                            <custom-select v-model="chartConfig.otherColumnIds"
                                           :options="selectableColumns"
                                           :settings="{multiple: true}"/>
                            <div class="mt-1">
                                <a href="#"
                                   @click.prevent="chartConfig.otherColumnIds = options.pages[chartConfig.pageIndex].selectable_columns.map((row) => row.id)">
                                    <small>
                                        <i class="fas fa-fw fa-plus-circle"></i>
                                        Alle
                                    </small>
                                </a>
                                |
                                <a href="#" @click.prevent="chartConfig.otherColumnIds = []">
                                    <small>Leeren</small>
                                </a>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>
                                Typ
                            </label>
                            <select class="form-control" v-model="chartConfig.type">
                                <option value="bar">Balken</option>
                                <option value="line">Linien</option>
                                <option value="pie">Kreis</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>
                                Modus
                            </label>
                            <select class="form-control" v-model="chartConfig.mode">
                                <option value="column">Spalte</option>
                                <option value="row">Zeile</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <button type="button"
                                    class="btn btn-block btn-outline-primary"
                                    @click="refreshChart">
                                Übernehmen
                            </button>
                        </div>

                    </template>

                </div>
            </div>
        </div>

        <div class="col-8">
            <div class="card shadow">
                <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 class="m-0 font-weight-bold text-primary">
                        Diagramm
                    </h6>

                    <div class="dropdown no-arrow">
                        <a class="dropdown-toggle" href="#" role="button" id="chart-options"
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                             aria-labelledby="chart-options">
                            <a class="dropdown-item"
                               href="#"
                               @click.prevent="downloadChart">
                                PNG Download
                            </a>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <canvas id="chart-js"></canvas>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
// taken from https://www.chartjs.org/docs/latest/configuration/canvas-background.html
const chartBackgroundPlugin = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart, args, options) => {
        const {ctx} = chart;
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = options.color || '#ffffff';
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    }
};

export default {
    props: {
        token: {
            type: String,
            required: true
        },
        calculationId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            chart: null,
            options: null,
            datasets: [],
            chartConfig: {
                type: 'bar',
                pageIndex: null,
                mode: 'column',
                primaryRowIds: [],
                otherColumnIds: []
            }
        };
    },
    mounted() {
        // wait for chart js to load from cdn
        document.addEventListener('DOMContentLoaded', () => {
            //this.refreshChart();
        });
        this.fetchOptions();
    },
    methods: {
        refreshChart() {
            this.fetchDatasets().then(() => {
                if (!this.datasets.length) {
                    return;
                }
                this.chart?.destroy();
                this.chart = new Chart(document.getElementById('chart-js'), {
                    plugins: [chartBackgroundPlugin],
                    type: this.chartConfig.type,
                    data: {
                        labels: this.datasets[0].results.map((result) => {
                            return result.item.title;
                        }),
                        datasets: this.datasets.map((dataset) => {
                            return {
                                label: dataset.item.title,
                                data: dataset.results.map((result) => {
                                    const value = result.cell.value;
                                    if (result.cell.type === 'money') {
                                        return value / 100;
                                    }

                                    return value;
                                }),
                                borderWidth: 1
                            };
                        })
                    },
                    options: {
                        scales: {
                            y: {
                                beginAtZero: true
                            }
                        }
                    }
                });
            });
        },
        fetchOptions() {
            axios.get('/calculations/' + this.calculationId + '/chart/options').then((res) => {
                this.options = res.data;
            });
        },
        fetchDatasets() {
            return axios.post('/calculations/' + this.calculationId + '/chart/data', {
                page_index: this.chartConfig.pageIndex,
                mode: this.chartConfig.mode,
                // turn ids from custom select into original objects again
                primary_rows: this.chartConfig.primaryRowIds.map((id) => {
                    return this.options.pages[this.chartConfig.pageIndex].selectable_rows.find((row) => String(row.id) === String(id));
                }),
                other_columns: this.chartConfig.otherColumnIds.map((id) => {
                    return this.options.pages[this.chartConfig.pageIndex].selectable_columns.find((column) => String(column.id) === String(id));
                }),
            }).then((res) => {
                this.datasets = res.data;
            });
        },
        downloadChart() {
            if (!this.chart) {
                return;
            }
            const link = document.createElement('a');
            link.href = this.chart.toBase64Image();
            link.download = 'diagramm.png';
            link.click();
        }
    },
    computed: {
        selectableRows() {
            if (this.chartConfig.pageIndex === null) {
                return [];
            }

            return this.options.pages[this.chartConfig.pageIndex].selectable_rows.map((row) => {
                return {
                    id: row.id,
                    text: row.title
                };
            });
        },
        selectableColumns() {
            if (this.chartConfig.pageIndex === null) {
                return [];
            }

            return this.options.pages[this.chartConfig.pageIndex].selectable_columns.map((row) => {
                return {
                    id: row.id,
                    text: row.title
                };
            });
        }
    },
    watch: {
        'chartConfig.pageIndex'() {
            this.chartConfig.primaryRowIds = [];
            this.chartConfig.otherColumnIds = [];
        },
        chartConfig: {
            deep: true,
            handler() {
                this.refreshChart();
            }
        }
    }
}
</script>
